
import React, { useState, useEffect } from "react";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts/core";
import { BarChart } from "echarts/charts";
import {
  getTime,
  getDate,
  getDay,
  formatYaxisNumber,
} from "components/common/dateTime";
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import { useWindowSize } from "services/resizeservice";

function SOCComponent(props) {
  const [echartInstance, setEchartInstance] = useState(null);
  const size = useWindowSize();

  useEffect(() => {
    echartInstance?.resize();
  }, [size.width]);

  var xAxisData = [];
  var yAxisSoc10 = [];
  var yAxisSoc20 = [];
  var yAxisSoc30 = [];
  var yAxisSoc40 = [];
  var yAxisSoc50 = [];
  var yAxisSoc60 = [];
  var yAxisSoc70 = [];
  var yAxisSoc80 = [];
  var yAxisSoc90 = [];
  var yAxisSoc100 = [];
  if (props.loading === "true") {
    xAxisData = [];
    yAxisSoc10 = [];
    yAxisSoc20 = [];
    yAxisSoc30 = [];
    yAxisSoc40 = [];
    yAxisSoc50 = [];
    yAxisSoc60 = [];
    yAxisSoc70 = [];
    yAxisSoc80 = [];
    yAxisSoc90 = [];
    yAxisSoc100 = [];
  } else if (props.data != undefined) {
    props.data.map(function (obj) {
      if (props.selectValue === "HOUR_24" || props.selectValue === "HOUR_12") {
        xAxisData.push(getTime(obj.endDate));
      } else if (props.selectValue === "WEEK") {
        xAxisData.push(getDay(obj.endDate));
      } else {
        xAxisData.push(getDate(obj.endDate));
      }

      if (obj.soc10 === null) {
        obj.soc10 = 0;
        yAxisSoc10.push(obj.soc10);
      } else {
        yAxisSoc10.push(obj.soc10);
      }

      if (obj.soc20 === null) {
        obj.soc20 = 0;
        yAxisSoc20.push(obj.soc20);
      } else {
        yAxisSoc20.push(obj.soc20);
      }

      if (obj.soc30 === null) {
        obj.soc30 = 0;
        yAxisSoc30.push(obj.soc30);
      } else {
        yAxisSoc30.push(obj.soc30);
      }

      if (obj.soc40 === null) {
        obj.soc40 = 0;
        yAxisSoc40.push(obj.soc40);
      } else {
        yAxisSoc40.push(obj.soc40);
      }

      if (obj.soc50 === null) {
        obj.soc50 = 0;
        yAxisSoc50.push(obj.soc50);
      } else {
        yAxisSoc50.push(obj.soc50);
      }

      if (obj.soc60 === null) {
        obj.soc60 = 0;
        yAxisSoc60.push(obj.soc60);
      } else {
        yAxisSoc60.push(obj.soc60);
      }

      if (obj.soc70 === null) {
        obj.soc70 = 0;
        yAxisSoc70.push(obj.soc70);
      } else {
        yAxisSoc70.push(obj.soc70);
      }

      if (obj.soc80 === null) {
        obj.soc80 = 0;
        yAxisSoc80.push(obj.soc80);
      } else {
        yAxisSoc80.push(obj.soc80);
      }

      if (obj.soc90 === null) {
        obj.soc90 = 0;
        yAxisSoc90.push(obj.soc90);
      } else {
        yAxisSoc90.push(obj.soc90);
      }

      if (obj.soc100 === null) {
        obj.soc100 = 0;
        yAxisSoc100.push(obj.soc100);
      } else {
        yAxisSoc100.push(obj.soc100);
      }
    });
  }

  if (props.selectValue == "168") {
    xAxisData = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  }

  echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    BarChart,
    CanvasRenderer,
  ]);

  const options = () => ({
    color: [
      "#EA130C",
      "#E55F09",
      "#EEBA27",
      "#FFC600",
      "#CBDE20",
      "#9AAB04",
      "#52B130",
      "#00792C",
      "#23297A",
      "#065358",
    ],
    legend: {
      show: true,
      itemGap: 4,
      itemWidth: 7,
      top: "3px",
      icon: "Box",
      left: "4px",
      textStyle: {
        fontSize: "8",
        fontFamily: "JioType",
        fontStyle: "normal",
        color: "#C1C1C1",
      },
    },
    grid: {
      left: "15%",
      right: "5%",
      bottom: "20%",
      containLabel: true,
      height: "60%",
    },
    xAxis: {
      type: "category",
      data: xAxisData,
      name: "Time",
      nameLocation: "middle",
      nameGap: xAxisData?.every((element) => element === null) ? 20 : 40,
      nameTextStyle: {
        fontFamily: "JioType",
        fontStyle: "normal",
        fontWeight: 300,
        fontSize: "12",
        color: "#000000",
      },
      axisLabel: {
        rotate:
          props.selectValue === "WEEK_2" ||
          props.selectValue === "MONTH" ||
          props.selectValue === "MONTH_3"
            ? 30
            : 0,
      },
    },
    yAxis: {
      type: "value",
      name: "No of Times",
      nameLocation: "middle",
      nameGap: xAxisData?.every((element) => element === null) ? 10 : 40,
      // nameGap: 40,
      axisLabel: {
        formatter: formatYaxisNumber,
      },
      nameTextStyle: {
        fontFamily: "JioType",
        fontStyle: "normal",
        fontWeight: 300,
        fontSize: "12",
        color: "#000000",
      },
    },
    series: [
      {
        name: "10%",
        type: "bar",
        stack: "total",
        label: {
          // show: true
        },
        emphasis: {
          focus: "series",
          label: {
            show: true,
          },
        },
        // data: [],
        data: yAxisSoc10,
      },
      {
        name: "20%",
        type: "bar",
        stack: "total",
        label: {
          // show: true
        },
        emphasis: {
          focus: "series",
          label: {
            show: true,
          },
        },
        data: yAxisSoc20,
      },
      {
        name: "30%",
        type: "bar",
        stack: "total",
        label: {
          // show: true
        },
        emphasis: {
          focus: "series",
          label: {
            show: true,
          },
        },
        // data: [80, 60, 20, 70, 40, 50, 60, 40, 50, 40],
        data: yAxisSoc30,
      },
      {
        name: "40%",
        type: "bar",
        stack: "total",
        label: {
          // show: true
        },
        emphasis: {
          focus: "series",
          label: {
            show: true,
          },
        },
        // data: [60, 30, 20, 30, 40, 50, 30, 40, 50, 40],\
        data: yAxisSoc40,
      },
      {
        name: "50%",
        type: "bar",
        stack: "total",
        label: {
          // show: true
        },
        emphasis: {
          focus: "series",
          label: {
            show: true,
          },
        },
        // data: [30, 80, 20, 30, 40, 50, 40, 40, 50, 30],
        data: yAxisSoc50,
      },
      {
        name: "60%",
        type: "bar",
        stack: "total",
        label: {
          // show: true
        },
        emphasis: {
          focus: "series",
          label: {
            show: true,
          },
        },
        // data: [50, 30, 20, 30, 40, 50, 51, 40, 50, 91],
        data: yAxisSoc60,
      },
      {
        name: "70%",
        type: "bar",
        stack: "total",
        label: {
          // show: true
        },
        emphasis: {
          focus: "series",
          label: {
            show: true,
          },
        },
        // data: [90, 40, 20, 30, 40, 50, 40, 40, 50, 61],
        data: yAxisSoc70,
      },
      {
        name: "80%",
        type: "bar",
        stack: "total",
        label: {
          // show: true
        },
        emphasis: {
          focus: "series",
          label: {
            show: true,
          },
        },
        // data: [30, 50, 20, 30, 40, 50, 60, 40, 50, 51],
        data: yAxisSoc80,
      },
      {
        name: "90%",
        type: "bar",
        stack: "total",
        label: {
          // show: true
        },
        emphasis: {
          focus: "series",
          label: {
            show: true,
          },
        },
        // data: [40, 30, 20, 30, 40, 50, 51, 40, 50, 51],
        data: yAxisSoc90,
      },
      {
        name: "100%",
        type: "bar",
        stack: "total",
        label: {
          // show: true
        },
        emphasis: {
          focus: "series",
          label: {
            show: true,
          },
        },
        // data: [20, 60, 20, 30, 40, 50, 80, 40, 50],
        data: yAxisSoc100,
      },
    ],
  });
  return (
    <ReactEcharts
      styles={{ with: "100%", height: "80%" }}
      echarts={echarts}
      notMerge={true}
      lazyUpdate={true}
      theme={"theme_name"}
      onChartReady={(instance) => {
        setEchartInstance(instance);
      }}
      opts={{ renderer: "svg" }}
      option={options()}
    />
  );
}

export default SOCComponent;
